/* src/app/modules/expense/expenses/expense.component.css */
.ef-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.ef-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.ef-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ef-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.ef-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.ef-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.ef-header__summary {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--cf-bg, #f4f6f8);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  padding: 8px 16px;
}
.ef-header__summary-divider {
  width: 1px;
  height: 28px;
  background: var(--cf-border, #e5e7eb);
}
.ef-header__summary-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.ef-header__summary-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cf-text-muted, #6b7280);
}
.ef-header__summary-value {
  font-size: 0.925rem;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
  font-variant-numeric: tabular-nums;
}
.ef-header__summary-value--total {
  font-size: 1.05rem;
  color: var(--cf-brand-dark, #4d7a00);
}
.ef-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.ef-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.ef-btn-save[disabled] {
  background: var(--cf-border, #e5e7eb) !important;
  color: var(--cf-text-muted, #9ca3af) !important;
  box-shadow: none !important;
}
.ef-body {
  padding: 14px 20px;
  flex: 1;
}
.ef-grid {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 16px;
  align-items: start;
}
@media (max-width: 1100px) {
  .ef-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .ef-body {
    padding: 10px 12px;
  }
  .ef-header {
    padding: 10px 14px;
  }
}
.ef-section {
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius-lg, 12px);
  overflow: hidden;
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0,0,0,0.08));
  margin-bottom: 10px;
}
.ef-section:last-child {
  margin-bottom: 0;
}
.ef-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--cf-bg, #f4f6f8);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cf-text, #1a1d23);
}
.ef-section__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--cf-brand, #e3fd64);
  flex-shrink: 0;
}
.ef-section__head-extra {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ef-section__body {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.ef-preview-body {
  padding: 12px;
  max-height: 65vh;
  overflow-y: auto;
}
.ef-pdf-container {
  width: 100%;
  height: 60vh;
}
.ef-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}
@media (max-width: 600px) {
  .ef-two-col {
    grid-template-columns: 1fr;
  }
}
.ef-field-with-help {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.ef-field-with-help > :first-child {
  flex: 1;
}
.ef-activity-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 0 16px;
  margin-bottom: 4px;
}
.ef-subsection-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--cf-text-muted, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 4px 0 4px;
}
.ef-radio-row {
  display: flex;
  gap: 20px;
  padding: 2px 0 6px;
  flex-wrap: wrap;
}
.ef-btn-secondary {
  font-size: 0.8rem !important;
  border-color: var(--cf-border, #e5e7eb) !important;
  color: var(--cf-text-muted, #6b7280) !important;
}
.ef-btn-secondary:hover {
  color: var(--cf-text, #1a1d23) !important;
  border-color: var(--cf-border-strong, #d1d5db) !important;
}
.ef-warn-text {
  font-size: 0.75rem;
  color: var(--cf-error, #dc2626);
}
.ef-line-wrap {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  padding: 10px 12px;
  margin-bottom: 8px;
  background: var(--cf-bg, #f4f6f8);
}
.ef-btn-remove-line {
  margin-top: 8px;
  font-size: 0.8rem !important;
  color: var(--cf-error, #dc2626) !important;
  border-color: rgba(220, 38, 38, 0.3) !important;
}
.ef-btn-remove-line:hover {
  background: #fef2f2 !important;
  border-color: var(--cf-error, #dc2626) !important;
}
.ef-line-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 4px 0 8px;
}
.ef-btn-add-line {
  font-size: 0.825rem !important;
  border-color: var(--cf-brand, #e3fd64) !important;
  color: var(--cf-brand-dark, #4d7a00) !important;
}
.ef-btn-add-line:hover {
  background: var(--cf-brand-light, #f9ffe0) !important;
}
.ef-totals {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  overflow: hidden;
  margin-top: 12px;
}
.ef-totals__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.ef-totals__row:last-child {
  border-bottom: none;
}
.ef-totals__row--final {
  background: var(--cf-bg, #f4f6f8);
}
.ef-totals__label {
  color: var(--cf-text-muted, #6b7280);
  font-weight: 500;
}
.ef-totals__value {
  font-variant-numeric: tabular-nums;
  color: var(--cf-text, #1a1d23);
}
.ef-totals__value--total {
  font-size: 1rem;
  color: var(--cf-brand-dark, #4d7a00);
}
::ng-deep .ef-page .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .ef-page .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
.ef-hint-danger {
  color: var(--cf-error, #dc2626) !important;
  font-weight: 700 !important;
}
.ef-field--duplicate .mdc-notched-outline__leading,
.ef-field--duplicate .mdc-notched-outline__notch,
.ef-field--duplicate .mdc-notched-outline__trailing {
  border-color: var(--cf-error, #dc2626) !important;
}
.ef-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 18px;
}
.ef-loading__icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--cf-brand, #e3fd64);
  opacity: 0.6;
}
.ef-loading__text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--cf-text-muted, #6b7280);
}
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
}
.dlg-hdr__icon {
  color: var(--cf-brand, #e3fd64);
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.dlg-hdr__close {
  color: #9ca3af !important;
  flex-shrink: 0;
}
.dlg-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 40px 24px;
  font-size: 13px;
  color: var(--cf-text-muted, #6b7280);
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid var(--cf-border, #e5e7eb);
  gap: 8px;
}
.act-body {
  padding: 20px 20px 8px !important;
}
.act-hint {
  font-size: 13px;
  color: var(--cf-text-muted, #6b7280);
  margin: 0 0 16px;
  line-height: 1.5;
}
.act-result {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
}
.act-result mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}
.act-result--success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #15803d;
}
.act-result--success mat-icon {
  color: #16a34a;
}
.act-result--error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
}
.act-result--error mat-icon {
  color: #dc2626;
}
/*# sourceMappingURL=expense.component.css.map */
